import { useCabinetMemberMe } from '@/hooks/useCabinetMemberMe';

/**
 * Returns the current user's license-exempt status.
 *
 * license_exempt = true means the user bypasses the Stripe paywall entirely,
 * regardless of the cabinet's subscription state. Replaces the old `is_staff`
 * boolean that was dropped in migration 058.
 *
 * Derives from the centralized useCabinetMemberMe cache — no additional fetch.
 */
export const useLicenseExempt = () => {
  const { data, isLoading, error } = useCabinetMemberMe();

  return {
    isLicenseExempt: data?.license_exempt ?? false,
    isLoading,
    error,
  };
};
